var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.027,
    height: 59.443,
    viewBox: "0 0 65.027 59.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconVideo2",
    transform: "translate(4155.719 13686.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-insert-photo",
    "data-name": "Icon material-insert-photo",
    d: "M33.672,6.227a3.455,3.455,0,0,0-3.445-3.444L-1.88-4.725A3.455,3.455,0,0,0-5.324-1.281l8,31.619a3.455,3.455,0,0,0,3.444,3.444ZM12.143,20.866l-6.028,7.75Z",
    transform: "translate(-4108.021 -13658.924) rotate(135)",
    fill: "#03738c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M32.868,16.156H21.491V4.778A2.529,2.529,0,0,0,18.962,2.25H16.434a2.529,2.529,0,0,0-2.528,2.528V16.156H2.528A2.529,2.529,0,0,0,0,18.684v2.528A2.529,2.529,0,0,0,2.528,23.74H13.906V35.118a2.529,2.529,0,0,0,2.528,2.528h2.528a2.529,2.529,0,0,0,2.528-2.528V23.741H32.868A2.529,2.529,0,0,0,35.4,21.212V18.684a2.529,2.529,0,0,0-2.532-2.528Z",
    transform: "translate(-4126.092 -13664.779)",
    fill: "#f97878"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/IconVideo.8fcbf67fad1448079fdee4bcf6465c6a.svg";
export { ForwardRef as ReactComponent };